import { TooltipSchemeDefinition } from "./tooltip-types";
import { BackgroundColor } from "../../background/constants/background-types";
import { toConstantCase } from "../../../utils/string-format";
import * as AllColors from "../../../constants/colors";
import { createTooltipMapDefinition } from "../../../utils/scheme-helper";

function createSchemes() {
  let newSchemes: AllColors.TooltipSchemeConfiguration<TooltipSchemeDefinition> = {};

  AllColors.TOOLTIP_SCHEMES.forEach((element) => {
    newSchemes[element.schemeName] = {
      backgroundColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}`],
      innerContentColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}_FONT`]
    };
    if (element.scheme) {
      newSchemes[element.schemeName] = { ...newSchemes[element.schemeName], ...element.scheme };
    }
  });
  return newSchemes;
}

export const TOOLTIP_SCHEME_CONFIG: AllColors.TooltipSchemeConfiguration<TooltipSchemeDefinition> = createSchemes();

export const TOOLTIP_SCHEME_MAP: Map<BackgroundColor | "default", TooltipSchemeDefinition> = new Map(
  Object.entries(createTooltipMapDefinition()).map(([background, config]) => [
    background as BackgroundColor,
    TOOLTIP_SCHEME_CONFIG[config as string]
  ])
);

export const TOOLTIP_PLACEMENT_TOP = "top";
export const TOOLTIP_PLACEMENT_RIGHT = "right";
export const TOOLTIP_PLACEMENT_BOTTOM = "bottom";
export const TOOLTIP_PLACEMENT_LEFT = "left";
export const TOOLTIP_PLACEMENTS = [
  TOOLTIP_PLACEMENT_TOP,
  TOOLTIP_PLACEMENT_RIGHT,
  TOOLTIP_PLACEMENT_BOTTOM,
  TOOLTIP_PLACEMENT_LEFT
] as const;

export const TOOLTIP_VISIBILITY_MANUAL = "manual";
export const TOOLTIP_VISIBILITY_ALWAYS = "always";
export const TOOLTIP_VISIBILITY_ON_HOVER = "onHover";
export const TOOLTIP_VISIBILITY_ON_CLICK = "onClick";
export const TOOLTIP_VISIBILITIES = [
  TOOLTIP_VISIBILITY_MANUAL,
  TOOLTIP_VISIBILITY_ALWAYS,
  TOOLTIP_VISIBILITY_ON_HOVER,
  TOOLTIP_VISIBILITY_ON_CLICK
] as const;

export const TOOLTIP_DEFAULT = "default";
export const TOOLTIP_SMALL = "small";
export const TOOLTIP_SIZE = [TOOLTIP_DEFAULT, TOOLTIP_SMALL] as const;
